import { useAccount, useBalance } from 'wagmi';
import { useConnectModal, useAccountModal, useChainModal } from '@rainbow-me/rainbowkit';
import { Contracts } from '../../../config/contracts';
import { useEffect, useState } from 'react';

export function useWeb3() {

  const { address, connector, isConnected, isConnecting, chain } = useAccount();

  const [cachedBalance, setCachedBalance] = useState(() => {
    const savedBalance = localStorage.getItem('balance');
    return savedBalance ? JSON.parse(savedBalance) : null;
  });

  const [cachedGainsBalance, setCachedGainsBalance] = useState(() => {
    const savedGainsBalance = localStorage.getItem('gainsBalance');
    return savedGainsBalance ? JSON.parse(savedGainsBalance) : null;
  });
  
  const { data: balance } = useBalance({
    address,
    chainId: chain?.id,
  })

  const { data: gainsBalance, refetch: refetchGains } = useBalance({
    address,
    chainId: chain?.id,
    token: Contracts.gains[chain?.id.toString() ?? '5'] as `0x${string}`
  })

  useEffect(() => {
    if (balance) {
      localStorage.setItem('balance', balance.formatted);
      setCachedBalance(balance);
    }
  }, [balance]);

  useEffect(() => {
    if (gainsBalance) {
      localStorage.setItem('gainsBalance', gainsBalance.formatted);
      setCachedGainsBalance(gainsBalance);
    }
  }, [gainsBalance]);

  return {
    chainId: chain?.id,
    account: isConnected ? address : null, // TODO: migrate using `isConnected` instead of account to check wallet auth
    isConnected,
    isConnecting,
    chain,
    connector,
    balance: cachedBalance,
    gainsBalance: cachedGainsBalance,
    refetchGains,
  };
}

export function useWalletConnect() {
  const { openConnectModal } = useConnectModal();
  const { openAccountModal } = useAccountModal();
  const { openChainModal } = useChainModal();

  return {
    openConnectModal,
    openAccountModal,
    openChainModal,
  };
}
